import { serviceFields } from './DictionaryFields'

import type { IFieldConfig } from '@/Core/Contracts/UI/Form'

/**
 * Поля сім'ї `CrmList` — прості списки (`SPEC-007` §5.1, §7.5). Порядок — як
 * у легасі (`ListBaseField.js`): Назва, Сортування, Код. Системних рядків
 * тут немає, тож «Код» редагується завжди.
 *
 * `extra` — поштучні поля довідника (опис для документів у форм
 * оподаткування): стають після «Коду», перед службовою інформацією.
 */
export const crmListFields = (extra: Record<string, IFieldConfig> = {}): Record<string, IFieldConfig> => ({
    title: {
        label: 'Назва',
        type: 'string',
        isRequired: true,
    },
    sorting: {
        label: 'Сортування',
        type: 'number',
        defaultValue: 500,
    },
    code: {
        label: 'Код',
        type: 'string',
        isRequired: true,
    },
    ...extra,
    ...serviceFields(),
})

/** Колонки легасі: Назва · Сортування · Код (`SPEC-007` §7.4). */
export const CRM_LIST_COLUMNS = ['title', 'sorting', 'code']
